import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import DataTableWidget from './DataTableWidget';

export default compose(
  withCitiesAndStreets
)(DataTableWidget);
